import {v4} from "uuid";
import ReactDOMServer from "react-dom/server";
import {B5} from "./Internal/B5";
import {B1} from "./Internal/B1";
import {B2} from "./Internal/B2";
import {B3} from "./Internal/B3";
import {B4} from "./Internal/B4";
import {B6} from "./Internal/B6";
import {B7} from "./Internal/B7";
import {B9} from "./Internal/B9";
import {B10} from "./Internal/B10";
import {B11} from "./Internal/B11";
import {B12} from "./Internal/B12";
import {B13} from "./Internal/B13";
import {C1} from "./Compare/C1";
import {C2} from "./Compare/C2";
import {C3} from "./Compare/C3";
import {C4} from "./Compare/C4";
import {C5} from "./Compare/C5";
import {C6} from "./Compare/C6";
import {C7} from "./Compare/C7";
import {C8} from "./Compare/C8";
import {C9} from "./Compare/C9";
import {C10} from "./Compare/C10";
import {C11} from "./Compare/C11";
import {notification} from "antd";
import {C12} from "./Compare/C12";
import {C13} from "./Compare/C13";
import ResultOutputTable from "./ResultOutputTable";
import {C20} from "./Compare/C20";
import {C21} from "./Compare/C21";
import {B17} from "./Internal/B17";
import {B20} from "./Internal/B20";
import FilterText from "../FilterText";
import {B26} from "./Internal/B26";
import {B30} from "./Internal/B30";
import {B15} from "./Internal/B15";
import {B23} from "./Internal/B23";

const renderOutput = ({key, result, report, settings, globalVariables}) => {
    try {
        let renderer = null
        switch (key) {
            case 'B1': renderer = B1; break;
            case 'B2': renderer = B2; break;
            case 'B3': renderer = B3; break;
            case 'B4': renderer = B4; break;
            case 'B5': renderer = B5; break;
            case 'B6': renderer = B6; break;
            case 'B7': renderer = B7; break;
            case 'B9': renderer = B9; break;
            case 'B10': renderer = B10; break;
            case 'B11': renderer = B11; break;
            case 'B12': renderer = B12; break;
            case 'B13': renderer = B13; break;
            case 'B15': renderer = B15; break;
            case 'B17': renderer = B17; break;
            case 'B20': renderer = B20; break;
            case 'B23': renderer = B23; break;
            case 'B26': renderer = B26; break;
            case 'B30': renderer = B30; break;
            case 'C1': renderer = C1; break;
            case 'C2': renderer = C2; break;
            case 'C3': renderer = C3; break;
            case 'C4': renderer = C4; break;
            case 'C5': renderer = C5; break;
            case 'C6': renderer = C6; break;
            case 'C7': renderer = C7; break;
            case 'C8': renderer = C8; break;
            case 'C9': renderer = C9; break;
            case 'C10': renderer = C10; break;
            case 'C11': renderer = C11; break;
            case 'C12': renderer = C12; break;
            case 'C13': renderer = C13; break;
            case 'C20': renderer = C20; break;
            case 'C21': renderer = C21; break;
            default: break;
        }

        if(!renderer)
            return (<div>Add Render</div>)

        // After filter if no data remove error message
        let copyResult = JSON.parse(JSON.stringify(result || []))
        copyResult = copyResult.filter(row => !(row && row.data && row.data.length === 0))

        if(report) {
            const exceptionalRender = (r) => {
                try {
                    return renderer.RenderDescription({
                        text: '',
                        row: r,
                        settings,
                        globalVariables: globalVariables || {}
                    })
                }
                catch (exp) {
                    return `Result Error!`
                }
            }

            return (
                <>
                    {
                        copyResult?.map(r => {
                            return (
                                <>
                                    <div style={{marginBottom: 8}}>
                                        {exceptionalRender(r)}
                                        <br/>
                                    </div>
                                </>
                            )
                        })
                    }
                </>
            )
        }

        return (
            <>
                <ResultOutputTable
                    data={copyResult}
                    globalVariables={globalVariables}
                    Component={renderer.RenderDescription}
                />
            </>
        )
    }
    catch (exp) {
        console.log(exp)
        notification.error({
            message: `${key}: Results can not be showed!`
        })
    }
}


const RenderService = {
    renderOutput
}

export default RenderService